var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { align: "baseline" } },
    [
      _vm._t("label", function () {
        return [
          _vm.label && !_vm.hideLabel
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: _vm.labelSize } },
                [
                  _c(
                    "v-card",
                    { staticClass: "d-flex", attrs: { flat: "" } },
                    [
                      _vm.nullable
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-card",
                                          _vm._g(
                                            {
                                              attrs: { height: "32", flat: "" },
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-switch", {
                                              staticClass: "mt-0",
                                              attrs: { dense: "" },
                                              model: {
                                                value: _vm.nullValue,
                                                callback: function ($$v) {
                                                  _vm.nullValue = $$v
                                                },
                                                expression: "nullValue",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1538822060
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.nullValue ? "Disable" : "Enable")
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c("v-card", { attrs: { flat: "" } }, [
                        _c(
                          "span",
                          { class: "subtitle-1 " + _vm.disabledLabel },
                          [_vm._v(_vm._s(_vm.label))]
                        ),
                        _vm.hint
                          ? _c(
                              "div",
                              [
                                _vm.hint.length > 80
                                  ? [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            top: "",
                                            "max-width": "300",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "span",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "text-caption",
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.hint.substring(
                                                                0,
                                                                80
                                                              ) + "..."
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2743448281
                                          ),
                                        },
                                        [_c("span", [_vm._v(_vm._s(_vm.hint))])]
                                      ),
                                    ]
                                  : _c(
                                      "span",
                                      { staticClass: "text-caption" },
                                      [_vm._v(_vm._s(_vm.hint))]
                                    ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
      _vm.extraButton
        ? _c("v-col", { staticClass: "shrink" }, [_vm._t("extraButton")], 2)
        : _vm._e(),
      !_vm.nullable || (_vm.nullable && _vm.nullValue)
        ? _c(
            "v-col",
            { staticClass: "grow" },
            [
              _c("v-text-field", {
                attrs: { type: _vm.type, suffix: _vm.suffix },
                model: {
                  value: _vm.computedValue,
                  callback: function ($$v) {
                    _vm.computedValue = $$v
                  },
                  expression: "computedValue",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }